import { useLayoutEffect, useMemo, useState } from 'react';
// import { useStore } from 'src/stores';
import { page } from 'src/locale';
import { useWindowSize } from 'src/core/hooks';
import { HomePageProduct } from './products';

/**
 * <useProductsList /> props
 */
const useProductsListProps = () => {
  const { width } = useWindowSize();

  const locale = 'ua';

  const products = page.productsCarousel?.products;

  const [isShowAll, setShowAll] = useState(false);

  const showAll = () => {
    setShowAll(true);
  };

  useLayoutEffect(() => {
    const slickTrackElement = document.querySelector(
      '.slick-track'
    ) as HTMLElement;

    if (slickTrackElement && width < 425) {
      slickTrackElement.style.minWidth =
        slickTrackElement.childElementCount * 310 +
        (slickTrackElement.childElementCount - 1) * 15 +
        35 +
        'px';
    }
  }, [width]);

  return {
    width,
    locale,
    products,
    page,
    isShowAll,
    showAll
  };
};

export { useProductsListProps };
